import { useEffect } from "react";
import { useSelector } from "react-redux";
import { draftDialogPlaySelector } from "store/bailiff/task/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerPlay = ({ audio = null }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------

  const play = useSelector(draftDialogPlaySelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    play ? audio.play() : audio.pause();
  }, [play, audio]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerPlay;
